import React from "react";
import "./Furits.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faClock,
  faEnvelope,
  faArrowAltCircleLeft,
  faUser,
} from "@fortawesome/free-solid-svg-icons";
import Contact from "../../Components/LandingPageSections/Contact";
import Footer from "../../Components/Layout/Footer";
import { Link } from "react-router-dom";
function Furits() {
  return (
    <div className="furits">
      <div className="blog-logo">
        <Link to="/">
          <img src="/img/logo1.png"></img>
        </Link>
      </div>
      <div className="furits_flex">
        <div className="furits_apple">
          <img src="/img/apple-orange.jpg"></img>
          <h2 className="furit_heading">
            All Surgeries are not created equal!
          </h2>
          <div className="shoulde_process_f">
            <div className="shoudle_logo_f">
              <img src="img/second-blog.png"></img>
              <span className="bolg_card_f">SecondlookOrtho</span>
            </div>
            <div className="date">
              <div className="months_date">
                <FontAwesomeIcon icon={faClock} />
                <span className="spandate">8 months ago</span>
              </div>
              <div className="months_date">
                <FontAwesomeIcon icon={faEnvelope} />
                <span className="mass-num">2</span>
              </div>
            </div>
          </div>
          <div className="furit_para">
            All surgeries are not created equal. What does that mean? I get a
            lot of comments from patients that come back for their postoperative
            visits after doing PT and wonder why the patient next to them is
            doing so much better and they had “arthroscopic knee or shoulder
            surgery.” I am here to tell you that all surgeries are not created
            equal. <br></br>
            <br></br>That means that even if the patient next to you doing PT
            also had arthroscopic shoulder surgery and you feel that they are
            way ahead of you in there therapy, whether that is improved motion
            or strength, or less pain - They may have had a different procedure
            performed. If you had a arthroscopic rotator cuff repair your rehab
            is going to look much different than somebody who had arthroscopic
            biceps tenodesis, distal clavicle resection, or a subacromial
            decompression. The rehab after a rotator cuff repair is much longer
            because the tendon has to heal to the bone and this takes time.
            <br></br>
            <br></br> What about arthroscopic knee surgeries? If you had an
            arthroscopic ACL reconstruction or a meniscal repair, that rehab
            will look much different than somebody who had an arthroscopic
            meniscal debridement. So bottom line is stop worrying about what the
            next patient is doing and just focus on getting better at every
            therapy appointment. Trust me if you follow the guidelines, remain
            motivated and consistent with your PT, then you will see the results
            come. Good Luck! Hope this helps<br></br>
            <br></br>Sincerely, <br></br>
            <br></br>SecondLookOrtho Team
          </div>
          <div className="blog_post">
            <div className="icon">
              <FontAwesomeIcon icon={faArrowAltCircleLeft} />
            </div>
            <div className="text_f">
              <strong className="text_primery">Previous Post </strong>
              <h6>Welcome to SecondLookOrtho!</h6>
            </div>
          </div>
          <div className="comonts_post">
            Post Comments<span>(1)</span>
          </div>
          <div className="profle_sec">
            <div className="profl_img">
              <img src="/img/user.svg"></img>
            </div>
            <div className="profile_name">
              <div className="pro-nam">Rehman</div>
              <div className="pro-date">July 2021</div>
            </div>
          </div>
          <p class="into_p">
            Hello, I'm now 177cm My dream height is 188cm But is it possible? If
            i'll get limb leghting surgery?
          </p>
          <div className="leave_comment">Leave a reply</div>
          <div className="comment_input">
            <div className="comment_input1">
              <input
                // name="Name"
                className="comment_in"
                name="Name"
                placeholder="
              Name"
              />
            </div>
            <div className="comment_input2">
              <input
                name="Email"
                type="text"
                className="comment_in"
                placeholder="Your Email(Will not be published)"
              />
            </div>
            <div className="massege_furit">
              <textarea
                className="Massage_area_f"
                placeholder=" Type your Comment"
              ></textarea>
            </div>
          </div>
          <button className="furit_btn">Submit Comment</button>
        </div>
        <div className="furits_div2">
          <header className="widget-header">
            <h6 className="weight-header-h3">Latest Posts</h6>
          </header>
          <div className="blog-posts">
            <div className="weight-let-post">
              <div className="weight-divs">
                <div className="apple-weight">
                  <img src="/img/apple-orange.jpg"></img>
                </div>
                <div className="weight-tittle">
                  All Surgeries are not created equal!
                </div>
              </div>
              <div className="months_date-weight">
                <FontAwesomeIcon icon={faEnvelope} />
                <span className="mass-num">6</span>
              </div>
            </div>
            <div className="weight-let-post">
              <div className="weight-divs">
                <div className="apple-weight">
                  <img src="/img/blog22.png"></img>
                </div>
                <div className="weight-tittle">Welcome to SecondLookOrtho!</div>
              </div>
              <div className="months_date-weight">
                <FontAwesomeIcon icon={faEnvelope} />
                <span className="mass-num">6</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Contact />
      <Footer />
    </div>
  );
}

export default Furits;
